export const INVESTMENT_COUNTRY_CODES = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PT',
  'SK',
  'SI',
  'ES',
] as const;

export type InvestmentCountryCode = (typeof INVESTMENT_COUNTRY_CODES)[number];

export const isInvestmentCountryCode = (value: string): value is InvestmentCountryCode =>
  INVESTMENT_COUNTRY_CODES.some((country) => country === value);

export const DEFAULT_INVESTMENT_COUNTRY: InvestmentCountryCode = 'ES';
